<template>
	<div class="operations">
		<div class="main">
			<div class="left">
				<div class="custom-tree-container">
					<el-tree
						:data="Treedata"
						default-expand-all
						:props="defaultProps"
						node-key="id"
						@node-click="handleNodeClick"
					></el-tree>
				</div>
			</div>
			<div class="right">
				<div class="title">
					<h1 style="text-align:center;">{{ this.dataName }}</h1>
					<div class="head">
						<div style="font-size:20px;line-height: 100px;">
							描述：{{ this.dataDescribe }}
						</div>
						<div style="display:flex;align-items: center;">
							<el-button
								type="warning"
								v-if="this.type === 4"
								@click="grouping"
								>换组</el-button
							>
							<el-button type="primary" @click="EditClick"
								>编辑</el-button
							>
							<el-button
								type="success"
								v-if="this.type === 1"
								@click="Addalert"
								>添加分部门</el-button
							>
							<el-button
								type="success"
								v-if="this.type === 2"
								@click="Addalert"
								>添加组</el-button
							>
							<el-button
								type="success"
								v-if="this.type === 3"
								@click="Addalert"
								>添加员工</el-button
							>
							<el-button
								type="danger"
								@click="Delete"
								v-if="this.type != 1"
								>删除</el-button
							>
						</div>
					</div>

					<div class="body" v-if="this.mainData.rid != ''">
						<div class="body-title">
							<span
								v-if="
									this.type === 1 ||
										this.type === 2 ||
										this.type === 3
								"
								>主管分配：</span
							>
							<span v-if="this.type === 4">角色分配：</span>
							<span class="associated" @click="associated"
								>关联用户</span
							>
						</div>
						<div class="table">
							<table
								class="tableData"
								cellpadding="0"
								cellspacing="0"
							>
								<tr>
									<th
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										姓名
									</th>
									<th
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										账号
									</th>
									<th style="width:33%;">操作</th>
								</tr>
								<tr>
									<td
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										{{ this.roleUserName }}
									</td>
									<td
										style="border-right:1px solid #ebeef5;width:33%;"
									>
										{{ this.telephone }}
									</td>
									<td style="width:33%;">
										<el-button type="danger" :disabled="!mainData || !mainData.telephone" @click="remove"
											>移除</el-button
										>
									</td>
								</tr>
							</table>
						</div>
					</div>

					<div class="body">
						<div class="body-title">
							产品分享权限分配：
							<el-button type="primary" size="mini" @click="share"
								>保存</el-button
							>
						</div>
						<div class="table">
							<div>
								<el-checkbox v-model="checked"
									>产品分享</el-checkbox
								>
							</div>
							<!-- <div style="margin-top: 20px;">
                                <el-checkbox v-model="checked1">产品分享特殊权限</el-checkbox>
                            </div> -->
						</div>
					</div>

					<div class="body">
						<div class="body-title">店铺分配</div>
						<div class="table">
							<el-table
								:data="shopdata"
								border
								style="width: 100%"
							>
								<el-table-column
									prop="shop_name"
									label="店铺名称"
									align="center"
								></el-table-column>
								<el-table-column
									prop="name"
									label="站点"
									align="center"
								>
									<template slot-scope="scope">
										<div
											v-for="item in tableCountry[
												scope.$index
											]"
											:key="item.id"
										>
											{{ item.countryName }}
										</div>
									</template>
								</el-table-column>
								<el-table-column label="操作" align="center">
									<template slot-scope="scope">
										<el-button
											@click="handleClick(scope.row)"
											type="danger"
											size="small"
											>移除</el-button
										>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 添加 -->
		<el-dialog :title="this.AddName" :visible.sync="Add" width="30%">
			<el-form ref="form" label-width="60px">
				<el-form-item label="名称">
					<el-input v-model="name" maxlength="20" show-word-limit placeholder="请输入名称（最多20个字符）"></el-input>
				</el-form-item>
				<el-form-item label="描述">
					<el-input v-model="describe"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="Add = false">取消</el-button>
				<el-button type="primary" @click="save">保存</el-button>
			</div>
		</el-dialog>
		<!-- 编辑 -->
		<el-dialog :title="this.EditName" :visible.sync="Edit" width="30%">
			<el-form ref="form" label-width="60px">
				<el-form-item label="名称">
					<el-input v-model="name1" :disabled="disable"></el-input>
				</el-form-item>
				<el-form-item label="描述">
					<el-input v-model="describe1"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="Edit = false">取消</el-button>
				<el-button type="primary" @click="EditSave">保存</el-button>
			</div>
		</el-dialog>
		<!-- 转移角色 -->
		<el-dialog title="转移角色" :visible.sync="ShiftingRoles" width="25%">
			<el-form ref="form" label-width="80px">
				<el-form-item label="分部门：">
					<el-select
						v-model="departmental"
						placeholder="选择分部门"
						@change="SelectDepartmental($event)"
						style="width:300px;"
					>
						<el-option
							v-for="item in departmentalList"
							:key="item.value"
							:label="item.departmentName"
							:value="item"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="组：">
					<el-select
						v-model="group"
						placeholder="选择组"
						style="width:300px;"
					>
						<el-option
							v-for="item in groupList"
							:key="item.value"
							:label="item.groupName"
							:value="item"
						>
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelTransfer">取消</el-button>
				<el-button type="primary" @click="transfer">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '../../../../api/api/api'
export default {
	name: 'department',
	components: {},
	data() {
		return {
			str: '',
			department: '',
			activeName: 'first',
			Treedata: [],
			mainData: '',
			roleUserName: '',
			telephone: '',
			name: '',
			name1: '',
			dataName: '',
			describe: '',
			dataDescribe: '',
			AddName: '',
			EditName: '',
			checked: '',
			checked1: '',
			shopdata: [],
			describe1: '',
			tableCountry: [],
			type: '',
			disable: '',
			Add: false,
			Edit: false,
			defaultProps: {
				children: 'child',
				label: 'name',
			},
			ShiftingRoles: false,
			departmental: '',
			group: '',
			departmentalList: [],
			groupList: [],
			// 缓存公司数据用于重复检查
			cachedCompanyData: null,
		}
	},
	created() {
		this.str = JSON.parse(localStorage.getItem('role'))
		this.informationAll()
	},
	methods: {
		handleNodeClick(data) {
			this.dataName = data.name
			this.dataDescribe = data.describe
			this.type = data.type
			// console.log(data,"大接口")
			var obj = {
				company_id: this.str.company_id,
				rid: data.rid,
				system: data.system,
				dgrId: data.dgrId,
				departmentId: data.departmentId,
			}
			ajaxPost(Baseurl + 'roleController/findRoleByRid', obj).then(
				(res) => {
					this.mainData = res.data.data
					this.roleUserName = this.mainData.roleUserName
					this.telephone = this.mainData.telephone
					this.shopdata = res.data.data.roleSeller
					this.checked = res.data.data.share
					this.checked1 = res.data.data.shareSpecial
					this.tableCountry = []
					for (var i = 0; i < this.shopdata.length; i++) {
						this.tableCountry.push(this.shopdata[i].countryMarks)
					}
				}
			)
		},
		informationAll() {
			var obj = {
				company_id: this.str.company_id,
				departmentName: '独立站运营部',
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextByDepartment',
				obj
			).then((res) => {
				this.dataName = res.data.data.Operation_Department.name
				this.dataDescribe = res.data.data.Operation_Department.describe
				this.type = res.data.data.Operation_Department.type

				this.mainData = res.data.data.Operation_Department
				this.roleUserName = this.mainData.roleUserName
				this.telephone = this.mainData.telephone
				// console.log(this.mainData,"默认调用的大接口")
				this.Treedata = [res.data.data.Operation_Department]
				this.shopdata =
					res.data.data.Operation_Department.departmentSeller
				// console.log(this.shopdata)
				for (
					var i = 0;
					i <
					res.data.data.Operation_Department.departmentSeller.length;
					i++
				) {
					this.tableCountry.push(
						res.data.data.Operation_Department.departmentSeller[i]
							.countryMarks
					)
				}
				// 缓存公司数据用于重复检查
				this.cachedCompanyData = res.data.data
				// console.log(this.Treedata)
			})
		},
		associated() {
			this.$prompt('账号', '关联用户', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			})
				.then(({ value }) => {
					if (value === '') {
						this.$message.error('账号不能为空')
					} else {
						var obj = {
							rid: this.mainData.rid,
							telephone: value,
						}
						ajaxPost(
							Baseurl + 'roleController/relationUser',
							obj
						).then((res) => {
							// console.log(res.data)
							if (res.data.code === 200) {
								this.$message({
									type: 'success',
									message: '关联用户成功',
								})
								this.mainData = res.data.data;
								this.roleUserName = this.mainData.roleUserName
								this.telephone = this.mainData.telephone
							} else {
								this.$message.error(res.data.data)
							}
						})
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '取消输入',
					})
				})
		},
		remove() {
			this.$confirm('是否确定移除该关联用户', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var obj = {
						rid: this.mainData.rid,
						system: this.mainData.system,
						telephone: this.mainData.telephone,
					}
					ajaxPost(
						Baseurl + 'roleController/cancelRelationUser',
						obj
					).then((res) => {
						if (res.data.code === 200) {
							this.$message({
								type: 'success',
								message: '移除用户成功',
							})
							this.mainData = res.data.data;
                            this.roleUserName = this.mainData.roleUserName;
                            this.telephone = this.mainData.telephone;
						} else {
							this.$message.error(res.data.data)
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消移除',
					})
				})
		},
		Addalert() {
			this.Add = true
			if (this.type === 1) {
				this.AddName = '添加分部门'
			} else if (this.type === 2) {
				this.AddName = '添加组'
			} else if (this.type === 3) {
				this.AddName = '添加员工'
			}
		},
		save() {
			// 使用缓存的数据检查重复，无需重新调用接口
			// 检查名称包含关系：新名称是已有名称的前缀，或已有名称是新名称的前缀
			if (!this.cachedCompanyData) {
				this.performSave()
				return
			}

			const allRoles = this.extractAllRoles(this.cachedCompanyData)
			const hasDuplicate = allRoles.some(role =>
				role.name.startsWith(this.name) || this.name.startsWith(role.name)
			)

			if (hasDuplicate) {
				// 找出所有相似的角色名称
				const duplicateRoles = allRoles.filter(role =>
					role.name.startsWith(this.name) || this.name.startsWith(role.name)
				)
				// 构建提示信息，每行显示一个相似名称（使用HTML的<br>换行）
				const namesList = duplicateRoles.map(r => `• ${r.name}`).join('<br>')
				this.$confirm(
					`已存在以下${duplicateRoles.length}个相似名称：<br><br>${namesList}<br><br>是否忽略并继续添加？`,
					'提示',
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true,
					}
				)
					.then(() => {
						// 用户点击确定，继续添加
						this.performSave()
					})
					.catch(() => {
						// 用户点击取消
						this.$message({
							type: 'info',
							message: '已取消添加',
						})
					})
			} else {
				// 没有重复，直接添加
				this.performSave()
			}
		},
		// 从公司数据中提取所有角色名称
		extractAllRoles(companyData) {
			const roles = []

			// companyData.Operation_Department 结构
			if (companyData.Operation_Department) {
				// 遍历所有分部门
				if (companyData.Operation_Department.child && companyData.Operation_Department.child.length > 0) {
					for (const dept of companyData.Operation_Department.child) {
						// 添加分部门的角色
						if (dept.name) roles.push({ name: dept.name })

						// 遍历所有组
						if (dept.child && dept.child.length > 0) {
							for (const group of dept.child) {
								// 添加组的角色
								if (group.name) roles.push({ name: group.name })

								// 遍历所有员工
								if (group.child && group.child.length > 0) {
									for (const employee of group.child) {
										// 添加员工的角色
										if (employee.name) roles.push({ name: employee.name })
									}
								}
							}
						}
					}
				}
			}

			return roles
		},
		// 执行保存操作
		performSave() {
			this.Add = false
			var obj = {
				company_id: this.str.company_id,
				dgrId: this.mainData.dgrId,
				name: this.name,
				describe: this.describe,
				system: this.mainData.system,
				departmentName: '独立站运营部',
			}
			ajaxPost(Baseurl + 'userControllers/insertDgr', obj).then((res) => {
				if (res.data.code === 200) {
					this.$message({
						type: 'success',
						message: '添加成功',
					})
					this.Treedata = [res.data.data.Operation_Department]
				} else {
					this.$message.error(res.data.data)
				}
				this.name = ''
				this.describe = ''
			})
		},
		EditClick() {
			this.Edit = true
			if (this.type === 1) {
				this.EditName = '编辑部门'
				this.disable = true
				this.name1 = this.dataName
				this.describe1 = this.dataDescribe
			} else if (this.type === 2) {
				this.EditName = '编辑分部门'
				this.disable = false
				this.name1 = this.dataName
				this.describe1 = this.dataDescribe
			} else if (this.type === 3) {
				this.EditName = '编辑组'
				this.disable = false
				this.name1 = this.dataName
				this.describe1 = this.dataDescribe
			} else if (this.type === 4) {
				this.EditName = '编辑员工'
				this.disable = false
				this.name1 = this.dataName
				this.describe1 = this.dataDescribe
			}
		},
		EditSave() {
			var obj = {
				company_id: this.str.company_id,
				dgrId: this.mainData.dgrId,
				departmentName: '独立站运营部',
				name: this.name1,
				system: this.mainData.system,
				describe: this.describe1,
			}
			ajaxPost(Baseurl + 'userControllers/editDgr', obj).then((res) => {
				if (res.data.code === 200) {
					console.log(res.data.data)
					this.$message({
						type: 'success',
						message: '修改成功',
					})
					this.Treedata = [res.data.data.Operation_Department]
					this.dataName = res.data.data.name
					this.dataDescribe = res.data.data.describe
				} else {
					this.$message.error(res.data.data)
				}
				this.name1 = ''
				this.describe1 = ''
			})

			this.Edit = false
		},
		Delete() {
			this.$confirm(
				'该操作将删除当前角色（组/分部门）的全部数据，是否继续',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}
			)
				.then(() => {
					var obj = {
						dgrId: this.mainData.dgrId,
						system: this.mainData.system,
					}
					ajaxPost(Baseurl + 'userControllers/deleteDgr', obj).then(
						(res) => {
							if (res.data.code === 200) {
								this.$message({
									type: 'success',
									message: '删除成功',
								})
								this.informationAll()
							} else {
								this.$message.error(res.data.data)
							}
						}
					)
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		share() {
			var obj = {
				rid: this.mainData.rid,
				share: this.checked,
				shareSpecial: this.checked1,
			}
			ajaxPost(
				Baseurl + 'roleController/allotProductSharingSpecial',
				obj
			).then((res) => {
				if (res.data.code === 200) {
					console.log(res.data)
					this.$message({
						type: 'success',
						message: '保存成功',
					})
				} else {
					this.$message.error(res.data.data)
				}
			})
		},
		handleClick(value) {
			var obj = {
				dgrId: value.dgrId,
				system: value.system,
				id: value.id,
				departmentId: value.departmentId,
			}
			ajaxPost(Baseurl + 'sellerController/removeSeller', obj).then(
				(res) => {
					if (res.data.code === 200) {
						console.log(res.data)
						this.$message({
							type: 'success',
							message: '移除成功',
						})
						this.shopdata = res.data.data.roleSeller
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		grouping() {
			this.ShiftingRoles = true
			var obj = {
				rid: this.str.rid,
				system: this.str.system,
				companyId: this.str.company_id,
				sellerType: 2
			}
			ajaxPost(Baseurl + 'roleController/selectNextInfoByRid', obj).then(
				(res) => {
					if (res.data.code === 200) {
						this.departmentalList = res.data.data.next
					}
				}
			)
		},
		SelectDepartmental(val) {
			var obj = {
				rid: val.rid,
				system: val.system,
				companyId: val.company_id,
			}
			ajaxPost(Baseurl + 'roleController/selectNextInfoByRid', obj).then(
				(res) => {
					if (res.data.code === 200) {
						this.groupList = res.data.data.next
					}
				}
			)
		},
		transfer() {
			var obj = {
				rid: this.mainData.rid,
				departmentChildId: this.departmental.did,
				gid: this.group.gid,
			}
			ajaxPost(Baseurl + 'roleController/roleTransfer', obj).then(
				(res) => {
					if (res.data.code === 200) {
						console.log(res.data)
						this.$message({
							type: 'success',
							message: res.data.data,
						})
						this.informationAll()
					} else {
						this.$message.error(res.data.data)
					}
					this.departmental = ''
					this.group = ''
					this.ShiftingRoles = false
				}
			)
		},
		cancelTransfer() {
			this.departmental = ''
			this.group = ''
			this.ShiftingRoles = false
		},
	},
}
</script>

<style lang="scss" scoped>
.left {
	padding: 30px;
	width: 20%;
	float: left;
	height: 700px;
	overflow-y: auto;
}
.custom-tree-container {
	margin-top: 30px;
}
.right {
	width: 80%;
	padding: 30px;
}
.main {
	width: 100%;
	display: flex;
	justify-content: space-between;
}
.head {
	display: flex;
	justify-content: space-between;
	height: 100px;
	border-bottom: 1px solid #e4e7ed;
}
.body {
	border: 1px solid #e4e7ed;
	padding: 15px;
	margin-top: 30px;
}
.body-title {
	width: 100%;
	height: 20px;
	padding: 10px;
	border-bottom: 1px solid #e4e7ed;
}
.table {
	margin-top: 30px;
}
.table table {
	width: 100%;
	height: 100px;
	text-align: center;
	border: 1px solid #ebeef5;
}
.table td {
	color: #606266;
}
.table th {
	border-bottom: 1px solid #ebeef5;
	color: #909399;
}
.associated {
	cursor: pointer;
	color: #409eff;
}
.el-form-item {
	margin-bottom: 0px;
}
</style>
